module.exports = __webpack_public_path__ + "img/ico_pos_attuale.8792692d.png";